package com.downdogapp.client

/**
 *  AUTO-GENERATED DO NOT EDIT!
 *  from [com.downdogapp.base.src.main.kotlin.com.downdogapp.tasks.FaqItems]
 */
// @formatter:off
enum class FaqItem(val question: String, val answer: String) {
  MUSIC_VOLUME_VS_VOICE(Strings.MUSIC_VOLUME_VS_VOICE_QUESTION, Strings.MUSIC_VOLUME_VS_VOICE_ANSWER),
  CHANGE_PLAYLIST_TYPE(Strings.CHANGE_PLAYLIST_TYPE_QUESTION, Strings.CHANGE_PLAYLIST_TYPE_ANSWER),
  TURN_OFF_MUSIC(Strings.TURN_OFF_MUSIC_QUESTION, Strings.TURN_OFF_MUSIC_ANSWER),
  CHANGE_VOICE(Strings.CHANGE_VOICE_QUESTION, Strings.CHANGE_VOICE_ANSWER),
  CHANGE_LANGUAGE(Strings.CHANGE_LANGUAGE_QUESTION, Strings.CHANGE_LANGUAGE_ANSWER),
  MAXIMUM_VERBOSITY(Strings.MAXIMUM_VERBOSITY_QUESTION, Strings.MAXIMUM_VERBOSITY_ANSWER),
  MINIMUM_VERBOSITY(Strings.MINIMUM_VERBOSITY_QUESTION, Strings.MINIMUM_VERBOSITY_ANSWER),
  SLOWER_PACE(Strings.SLOWER_PACE_QUESTION, Strings.SLOWER_PACE_ANSWER),
  SETTINGS_FOR_BEGINNERS(Strings.SETTINGS_FOR_BEGINNERS_QUESTION, Strings.SETTINGS_FOR_BEGINNERS_ANSWER),
  LEVEL(Strings.LEVEL_QUESTION, Strings.LEVEL_ANSWER),
  COMMUNITY(Strings.COMMUNITY_QUESTION, Strings.COMMUNITY_ANSWER),
  EXCLUDE_POSES(Strings.EXCLUDE_POSES_QUESTION, Strings.EXCLUDE_POSES_ANSWER),
  INCLUDE_POSES(Strings.INCLUDE_POSES_QUESTION, Strings.INCLUDE_POSES_ANSWER),
  POSE_LIBRARY(Strings.POSE_LIBRARY_QUESTION, Strings.POSE_LIBRARY_ANSWER),
  PRENATAL(Strings.PRENATAL_QUESTION, Strings.PRENATAL_ANSWER),
  VIDEO_MODEL(Strings.VIDEO_MODEL_QUESTION, Strings.VIDEO_MODEL_ANSWER),
  SUBTITLES(Strings.SUBTITLES_QUESTION, Strings.SUBTITLES_ANSWER),
  CAST(Strings.CAST_QUESTION, Strings.CAST_ANSWER),
  AIRPLAY(Strings.AIRPLAY_QUESTION, Strings.AIRPLAY_ANSWER),
  SAVE_FOR_OFFLINE(Strings.SAVE_FOR_OFFLINE_QUESTION, Strings.SAVE_FOR_OFFLINE_ANSWER),
  SAVE_TO_FAVORITES(Strings.SAVE_TO_FAVORITES_QUESTION, Strings.SAVE_TO_FAVORITES_ANSWER),
  RENAME_FAVORITES(Strings.RENAME_FAVORITES_QUESTION, Strings.RENAME_FAVORITES_ANSWER),
  SHARE_PRACTICE(Strings.SHARE_PRACTICE_QUESTION, Strings.SHARE_PRACTICE_ANSWER),
  GOOGLE_FIT(Strings.GOOGLE_FIT_QUESTION, Strings.GOOGLE_FIT_ANSWER),
  APPLE_HEALTH(Strings.APPLE_HEALTH_QUESTION, Strings.APPLE_HEALTH_ANSWER),
  FITBIT(Strings.FITBIT_QUESTION, Strings.FITBIT_ANSWER),
  CHANGE_EMAIL(Strings.CHANGE_EMAIL_QUESTION, Strings.CHANGE_EMAIL_ANSWER),
  CHANGE_PASSWORD(Strings.CHANGE_PASSWORD_QUESTION, Strings.CHANGE_PASSWORD_ANSWER),
  UNLINK_GOOGLE_FACEBOOK(Strings.UNLINK_GOOGLE_FACEBOOK_QUESTION, Strings.UNLINK_GOOGLE_FACEBOOK_ANSWER),
  DELETE_ACCOUNT(Strings.DELETE_ACCOUNT_QUESTION, Strings.DELETE_ACCOUNT_ANSWER),
  AUTO_RENEW_OFF(Strings.AUTO_RENEW_OFF_QUESTION, Strings.AUTO_RENEW_OFF_ANSWER),
  PRICE_DIFFERENCE(Strings.PRICE_DIFFERENCE_QUESTION, Strings.PRICE_DIFFERENCE_ANSWER),
  REFUND(Strings.REFUND_QUESTION, Strings.REFUND_ANSWER),
  SUBSCRIPTION_RENEWAL_PRICE(Strings.SUBSCRIPTION_RENEWAL_PRICE_QUESTION, Strings.SUBSCRIPTION_RENEWAL_PRICE_ANSWER),
  DEVICE_LIMIT(Strings.DEVICE_LIMIT_QUESTION, Strings.DEVICE_LIMIT_ANSWER),
  FAMILY_SHARING(Strings.FAMILY_SHARING_QUESTION, Strings.FAMILY_SHARING_ANSWER),
  CANT_ACCESS_SUBSCRIPTION(Strings.CANT_ACCESS_SUBSCRIPTION_QUESTION, Strings.CANT_ACCESS_SUBSCRIPTION_ANSWER),
  NO_SOUND(Strings.NO_SOUND_QUESTION, Strings.NO_SOUND_ANSWER),
  VIDEO_FREEZING(Strings.VIDEO_FREEZING_QUESTION, Strings.VIDEO_FREEZING_ANSWER),
  VIDEO_ACCIDENTALLY_MIRRORED(Strings.VIDEO_ACCIDENTALLY_MIRRORED_QUESTION, Strings.VIDEO_ACCIDENTALLY_MIRRORED_ANSWER),
  LOWER_VIDEO_QUALITY(Strings.LOWER_VIDEO_QUALITY_QUESTION, Strings.LOWER_VIDEO_QUALITY_ANSWER),
  CAST_TROUBLESHOOTING(Strings.CAST_TROUBLESHOOTING_QUESTION, Strings.CAST_TROUBLESHOOTING_ANSWER),
  MEMBERSHIP_DELAYED_START(Strings.MEMBERSHIP_DELAYED_START_QUESTION, Strings.MEMBERSHIP_DELAYED_START_ANSWER),
  ALL_APPS_PURCHASE(Strings.ALL_APPS_PURCHASE_QUESTION, Strings.ALL_APPS_PURCHASE_ANSWER),
  RECEIPTS(Strings.RECEIPTS_QUESTION, Strings.RECEIPTS_ANSWER),
  GIFT(Strings.GIFT_QUESTION, Strings.GIFT_ANSWER),
  LIFETIME(Strings.LIFETIME_QUESTION, Strings.LIFETIME_ANSWER),
  AFFILIATE(Strings.AFFILIATE_QUESTION, Strings.AFFILIATE_ANSWER),
  NO_EXCHANGE_FEES(Strings.NO_EXCHANGE_FEES_QUESTION, Strings.NO_EXCHANGE_FEES_ANSWER),
  CANNOT_MERGE_ACCOUNTS(Strings.CANNOT_MERGE_ACCOUNTS_QUESTION, Strings.CANNOT_MERGE_ACCOUNTS_ANSWER),
  PAYMENT_METHODS(Strings.PAYMENT_METHODS_QUESTION, Strings.PAYMENT_METHODS_ANSWER),
  HOW_TO_CANCEL(Strings.HOW_TO_CANCEL_QUESTION, Strings.HOW_TO_CANCEL_ANSWER),
  NO_PARTIAL_REFUND(Strings.NO_PARTIAL_REFUND_QUESTION, Strings.NO_PARTIAL_REFUND_ANSWER),
  SALE_PRICE(Strings.SALE_PRICE_QUESTION, Strings.SALE_PRICE_ANSWER),
  MONTHLY_TO_YEARLY(Strings.MONTHLY_TO_YEARLY_QUESTION, Strings.MONTHLY_TO_YEARLY_ANSWER),
  NOT_FREE(Strings.NOT_FREE_QUESTION, Strings.NOT_FREE_ANSWER),
  MANAGE_EMAIL_PREFERENCES(Strings.MANAGE_EMAIL_PREFERENCES_QUESTION, Strings.MANAGE_EMAIL_PREFERENCES_ANSWER),
  VIEW_PLAYLIST(Strings.VIEW_PLAYLIST_QUESTION, Strings.VIEW_PLAYLIST_ANSWER),
  GUIDED_MEDITATION_AND_BREATHING(Strings.GUIDED_MEDITATION_AND_BREATHING_QUESTION, Strings.GUIDED_MEDITATION_AND_BREATHING_ANSWER),
  YOGA_NIDRA_INFO(Strings.YOGA_NIDRA_INFO_QUESTION, Strings.YOGA_NIDRA_INFO_ANSWER),
  NO_MUSIC_OFFLINE(Strings.NO_MUSIC_OFFLINE_QUESTION, Strings.NO_MUSIC_OFFLINE_ANSWER),
  NIDRA_AUDIO_ONLY(Strings.NIDRA_AUDIO_ONLY_QUESTION, Strings.NIDRA_AUDIO_ONLY_ANSWER)
}
